module.exports = __webpack_public_path__ + "media/swift-promo.fc7c55a0.mp4";